import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spinner, Alert, Progress } from 'reactstrap';
import * as Actions from '../../actions/loadingActions';

class View extends PureComponent {
  render() {
    const {
      isLoading, errorMessage, cancelAlert, alert, progress, pauseProgress, resumeProgress,
    } = this.props;
    return (
      <>
        {isLoading && (
          <Spinner
            animation="border"
            role="status"
            style={{
              position: 'fixed',
              bottom: '2rem',
              right: '2rem',
              zIndex: 100,
            }}
            color="primary"
          >
            Loading...
          </Spinner>
        )}
        <Alert
          color="danger"
          isOpen={alert}
          toggle={cancelAlert}
          onMouseEnter={() => pauseProgress()}
          onMouseLeave={() => resumeProgress()}
          style={{
            marginBottom: 0,
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            zIndex: 100,
          }}
        >
          {errorMessage && errorMessage}
          <Progress
            color="danger"
            value={progress}
            striped
            animated
            style={{
              marginTop: '.1rem',
              height: '.2rem',
            }}
          />
        </Alert>
      </>
    );
  }
}

View.defaultProps = {
  errorMessage: null,
};

View.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  cancelAlert: PropTypes.func.isRequired,
  alert: PropTypes.bool.isRequired,
  progress: PropTypes.number.isRequired,
  pauseProgress: PropTypes.func.isRequired,
  resumeProgress: PropTypes.func.isRequired,
};

export default connect((state) => ({
  isLoading: state.loading.isLoading,
  errorMessage: state.loading.errorMessage,
  alert: state.loading.alert,
  progress: state.loading.progress,
}), (dispatch) => ({
  pauseProgress: () => dispatch({
    type: Actions.SAGA_PAUSE_PROGRESS,
  }),
  resumeProgress: () => dispatch({
    type: Actions.SAGA_RESUME_PROGRESS,
  }),
  cancelAlert: () => dispatch({
    type: Actions.SAGA_CANCEL_PROGRESS,
  }),
}))(View);
